const riot = require('riot');

riot.tag2('modal-group', '<div class="modal bg-white w472 s-w-full rounded-8 m8" ref="modal"> <form class="pt18 pb24 px16" onsubmit="{submit}" onkeydown="{selectionList.onKeyDown}"> <div class="f fm flex-between mb18"> <div class="f fm"> <div class="bold fs16 mr4">グループを{opts.group ? \'編集\' : \'作成\'}</div> <div class="p4 cursor-pointer tooltip" if="{opts.group}" onclick="{onOpenActionSheet}" aria-label="編集"><i class="icon-more_horizontal text-background_dark_primary fs24"></i></div> </div> <div class="p4 cursor-pointer" onclick="{close}"><i class="icon-close fs20 text-label_dark_medium"></i></div> </div> <div class="mb16"> <div class="f fm bold fs13 mb8">グループ名</div> <div class="relative f fm fs13 w-full"> <div class="absolute l8 t0 b0 f fh lh13">@</div> <input class="input light_secondary w-full pl20 pr7 lh13" ref="group_name" placeholder="グループ名を入力" riot-value="{opts.group.data.screen_name}" required> </div> </div> <div class="mb16"> <div class="f fm bold fs13 mb8">リマインドの対象にする</div> <div data-is="atom-switch" ref="enabled_remind"></div> </div> <div class="mb16"> <div class="f flex-between mb8"> <div class="bold fs13">ユーザー一覧</div> <div class="text-label_dark_medium"><span class="bold fs13">{getProjectUserCount()}</span><span class="fs11">/{workspaceUsers.length} user</span></div> </div> <div class="input small light_secondary f fm pr8"><i class="icon-search text-label_dark_disabled fs16 mr8"></i> <input class="w-full" ref="search" placeholder="ユーザーを検索" oninput="{debounceSearch}"><i class="icon-close fs16 cursor-pointer ml8" onclick="{onDeleteQuery}" if="{refs.search.value}"></i> </div> </div> <div class="block mb16"> <div class="border rounded-8 h222 overflow-scroll"> <div each="{workspace_user, index in displayUsers}" data-is="item-selection-list" item="{workspace_user}" onclick="{onToggleCheck}" selected-class="bg-pale"> <label class="f fm px8 py4 cursor-pointer"><i class="flex-fixed s16 fs16 mr8 {&quot;icon-check text-primary&quot;: workspace_user.checked}"></i> <div class="w-full" data-is="item-user" item="{workspace_user.user.relation.user}" role="{workspace_user.user.data.role}"></div> </label> </div> </div> </div> <div class="f overflow-scroll h20 mb24"> <div class="circle mrn6 s20 flex-fixed overflow-hidden border border-white bg-white" each="{user in getSelectedUsers()}"><img class="s-full object-fit-cover" riot-src="{app.utils.getImageUrl(user.user.relation.user.data.icon_image)}"></div> </div> <div class="text-center"> <button class="button w220 primary" ref="submitButton">{opts.group ? \'更新\' : \'作成\'}する</button> </div> </form> </div>', 'modal-group,[data-is="modal-group"]{background-color:rgba(0,0,0,0.5)} modal-group input::placeholder,[data-is="modal-group"] input::placeholder{color:rgba(29,40,76,0.2);font-size:13px} modal-group input:focus,[data-is="modal-group"] input:focus{outline:none !important}', 'class="f fh s-px8" spat-animation="push"', function(opts) {

    this.mixin('selectionList');
    this.on('mount', async () => {

      this.workspaceUsers = await app.store.workspace.fetchWorkspaceUsers();

      this.workspaceUsers = this.workspaceUsers.map(workspace_user => {
        let checked = false;
        if (this.opts.group) {
          checked = this.opts.group.data.user_ids.some(id => id === workspace_user.data.user_id);
        }
        return {
          checked,
          user: workspace_user,
        };
      });

      this.displayUsers = app.utils.displayUsersSort(this.workspaceUsers, (user) => user.user.relation.user);
      this.update();

      if (this.opts.group) {
        this.refs.search.focus();
        this.refs.enabled_remind.setValue(this.opts.group.data.enabled_remind);
      }

      else {
        this.refs.group_name.focus();
        this.refs.enabled_remind.setValue(false);
      }
    });

    this.onOpenActionSheet = (e) => {

      let options = [
        {
          label: '削除',
          icon: 'stash_box',
          action: () => {
            popup.close();
            this.deleteGroup();
          },
          accent: true,
        },
      ];
      const popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 0,
        position: 'bottom',
        opts: {
          options: options,
        },
      });
    };

    this.deleteGroup = async () => {
      let result = await spat.modal.confirm(`<b>@${this.opts.group.data.screen_name}</b>を完全に削除しますか？\nこの操作を行うと元に戻せません。`, '', {
        positive: '削除',
      });
      if (!result) return;

      await app.store.workspace.deleteGroup(this.opts.group.id);

      app.utils.openToast('deleteGroup', {label: this.opts.group.data.screen_name});

      this.value = "delete";
      this.close();
    };

    this.workspaceUsers = [];

    this.submit = async (e) => {
      e.preventDefault();
      if (this.isExistName(this.refs.group_name.value)) {
        spat.modal.alert('そのグループ名は使用されています。');
        return;
      }
      let i = spat.modal.indicator();
      let users_ids = this.workspaceUsers.filter(tu => !!tu.checked).map(tu => tu.user.relation.user.id);
      let data = {
        screen_name: this.refs.group_name.value || this.opts.group.data.name,
        user_ids: users_ids || [],
        enabled_remind: this.refs.enabled_remind.getValue(),
      };
      try {
        if (this.opts.group) {
          this.value = await this.opts.group.parent.parent.updateGroup(this.opts.group.id, data);
          spat.modal.alert('変更しました');
        } else {
          this.value = await app.store.workspace.createGroup(data);
          spat.modal.alert('登録しました');
        }
      }
      catch (e) {
        spat.modal.alert(e.message);
      }
      finally {
        i.close();
        this.close();
      }
    };

    this.onToggleCheck = (e) => {
      e.item.workspace_user.checked = !e.item.workspace_user.checked;
      this.update();
    };

    this.getSelectedUsers = () => {
      return this.workspaceUsers.filter(user => user.checked);
    };

    this.getProjectUserCount = () => {
      return this.workspaceUsers.filter(tu => tu.checked).length;
    };

    this.debounceSearch = _.debounce(() => {
      let value = this.refs.search.value;
      if (!value) {
        this.displayUsers = this.workspaceUsers
        this.update();
        return;
      }

      this.displayUsers = [];

      this.displayUsers = app.utils.filterUsers(this.workspaceUsers, value, (user) => user.user.relation.user);
      this.update();
    }, 128);

    this.isExistName = (name) => {
      return this.opts.other_groups.some(group => {
        return group.data.screen_name === name;
      });
    };

    this.onDeleteQuery = () => {
      this.refs.search.value = '';
      this.refs.search.focus();
      this.displayUsers = this.workspaceUsers;
      this.update();
    };

    this.on('selectionList.keydown', (e) => {

      if (document.activeElement === this.refs.group_name) {

        e.preventSelectionList = true;
      }
    });

    this.on('selectionList.keydown.enter', (e) => {
      const isNotButton = document.activeElement === this.refs.submitButton;

      if (!isNotButton) {
        e.preventDefault();
        let selected_user = this.displayUsers[this.selectionList.selectedIndex];
        selected_user.checked = !selected_user.checked;
      }
    });
});